import { InternalApiEntitySchemaField } from '../../../api-internal';
import { getDisplayValue } from '../../../schema/helper';
import { getHighlightedValue } from './highlighters';

interface Props {
  value: string;
  schemaFields: InternalApiEntitySchemaField[] | undefined;
  fieldAccessor: {
    parentFieldName: string;
    attributeIndex: number;
    childFieldName: string;
  };
  highlightedFields?: string[];
}

const ChildValue = ({ value, schemaFields, fieldAccessor, highlightedFields }: Props) => {
  const { parentFieldName, attributeIndex, childFieldName } = fieldAccessor;
  const schemaField = schemaFields?.find((schemaField) => schemaField.fieldName === childFieldName);
  const formattedValue = getDisplayValue(schemaField, value);
  if (
    highlightedFields?.includes(`${parentFieldName}.${childFieldName}`) ||
    highlightedFields?.includes(`${parentFieldName}[${attributeIndex}]`) ||
    highlightedFields?.includes(`${parentFieldName}[${attributeIndex}].${childFieldName}`)
  ) {
    return getHighlightedValue({ text: formattedValue, highlight: formattedValue });
  }
  return formattedValue;
};

export default ChildValue;
